import { NotificationService } from '../../../common/services';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { SvgIconLoad } from './svg-icon.actions';
import { SvgIconService } from './svg-icon.service';

export interface SvgIconStateModel {
  loaded: boolean;
}

const initialState: SvgIconStateModel = {
  loaded: false,
};

@State<SvgIconStateModel>({
  name: 'svgIcon',
  defaults: initialState,
})
@Injectable()
export class SvgIconState {
  constructor(private svgIconService: SvgIconService, private notificationService: NotificationService) {}
  @Selector()
  static getState(state: SvgIconStateModel): SvgIconStateModel {
    return state;
  }
  @Selector()
  static getLoaded(state: SvgIconStateModel): boolean {
    return state.loaded;
  }

  @Action(SvgIconLoad)
  getSvgIcon(ctx: StateContext<SvgIconStateModel>, { svgPath }: SvgIconLoad): void {
    this.svgIconService.svgIconMap.set(svgPath, this.svgIconService.getSvgIcon(svgPath));
  }
}
